export interface IHubspotPropertyForDropdown {
    id: string;
    text: string;
}

export interface IHubspotPropertiesForDropdown {
    hubspotProperties: IHubspotPropertyForDropdown[];
}
